import {
  Backdrop,
  CircularProgress,
  Fade,
  Grid,
  Snackbar,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MuiAlert from "@material-ui/lab/Alert";
import instance from "api/globalaxios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createCase, updateCase } from "slices/casesSlice";
import { joinHearingRooms } from "./Assign";
import CloseModalButton from "Admin/Common/CloseModalButton";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "3rem auto",
    height: "80%",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      height: "80%",
      padding: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      height: "80%",
      padding: "0.5rem",
    },
  },
  assign: {
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "23px",
    letterSpacing: "0.6px",
    color: "#454545",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "18px",
    },
  },
  caseId: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: "#454545",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
  profileType: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: "#454545",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
  box: {
    padding: "0.7rem",
  },
  box2: {
    cursor: "pointer",
    padding: "0.7rem",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
  profileheading: {
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "16px",
    color: "#25213B",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "14px",
    },
  },
  profileheading: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#25213B",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "14px",
    },
  },
}));

export default function Assign({
  openmodal,
  handleCloseModal,
  caseId,
  profileType,
  type,
  dispute,
  allAssignedPrifiles,
  updateDisputeName,
  casefiles,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [profiles, setProfiles] = useState([]);

  const [openSnackBar1, setOpenSnackBar1] = useState(false);
  const handleCloseSnackBar1 = () => {
    setOpenSnackBar1(false);
  };

  React.useEffect(() => {
    dispatch(getUsers());
  }, []);

  function getUsers() {
    return async () => {
      try {
        const response = await instance.get(
          `/api/userappointmentprofilelist/${null}/${null}/${profileType}`
        );
        setProfiles(response.data.profiles);
        setLoading(false);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    };
  }

  const assignUser = (profile) => {
    let caseBody = {};
    let c_casefiles = [];
    let r_casefiles = [];
    casefiles.map((item) => {
      if (item.type == "claimant") c_casefiles.push(item);
      else r_casefiles.push(item);
    });
    if (
      type == "claimant" &&
      c_casefiles.length == 1 &&
      c_casefiles[0].profile == null
    ) {
      caseBody = {
        id: c_casefiles[0].id,
        profile: profile.id,
      };
      dispatch(updateCase(caseBody)).then(() => {
        setOpenSnackBar1(true);
        updateDisputeName();
        dispatch(joinHearingRooms(caseId));
        // dispatch(
        //   updateDispute({
        //     id: dispute.id,
        //     rv_claimant_choose_step_complete: true,
        //   })
        // ).then(() => {});
      });
    } else if (
      type == "respondent" &&
      r_casefiles.length == 1 &&
      r_casefiles[0].profile == null
    ) {
      caseBody = {
        id: r_casefiles[0].id,
        profile: profile.id,
      };
      dispatch(updateCase(caseBody)).then(() => {
        setOpenSnackBar1(true);
        updateDisputeName();
        dispatch(joinHearingRooms(caseId));
        // dispatch(
        //   updateDispute({
        //     id: dispute.id,
        //     rv_respondent_choose_step_complete: true,
        //   })
        // ).then(() => {});
      });
    } else {
      caseBody = {
        summary: dispute.description,
        description: dispute.description,
        profile: profile.id,
        dispute: dispute.id,
        type: type,
        lawyer_rv: [],
      };

      dispatch(createCase(caseBody)).then(() => {
        setOpenSnackBar1(true);
        updateDisputeName();
        dispatch(joinHearingRooms(caseId));
      });
    }
  };

  const body = (
    <div className={classes.paper}>
      <CloseModalButton onClick={handleCloseModal} />
      <Typography className={classes.assign}>Assign</Typography>
      <Box height="0.5rem"></Box>
      <Typography className={classes.caseId}>
        Case Id : {dispute.approved ? dispute.tiac_custom_dispute_id : "---"}
      </Typography>
      <Box height="0.5rem"></Box>
      <Typography className={classes.profileType}>
        Profile Type : Party
      </Typography>
      <Box height="1.5rem"></Box>
      <Grid container justify="center">
        <Grid item sm={10} xs={12}>
          <Box className={classes.box}>
            <Grid container justify="space-between">
              <Grid item sm xs style={{ textAlign: "left" }}>
                <Typography className={classes.profileheading}>Name</Typography>
              </Grid>
              <Grid item sm xs style={{ textAlign: "right" }}>
                <Typography className={classes.profileheading}>
                  Email
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {profiles.map((profile) => {
            if (
              !allAssignedPrifiles.some((item) => item.profile.id == profile.id)
            )
              return (
                <Box
                  key={profile.id}
                  className={classes.box2}
                  onClick={(e) => {
                    assignUser(profile);
                  }}
                >
                  <Grid container justify="space-between">
                    <Grid item sm xs style={{ textAlign: "left" }}>
                      <Typography className={classes.profile}>
                        {profile.user.first_name} {profile.user.last_name}
                      </Typography>
                    </Grid>
                    <Grid item sm xs style={{ textAlign: "right" }}>
                      <Typography className={classes.profile}>
                        {profile.user.email}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              );
          })}
        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar1}
        onClose={handleCloseSnackBar1}
        message="Assigned"
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="success">
          Assigned
        </Alert>
      </Snackbar>
    </div>
  );

  if (loading) {
    return <CircularProgress />;
  }
  return (
    <Modal
      open={openmodal}
      onClose={handleCloseModal}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableEnforceFocus
    >
      <Fade in={openmodal}>{body}</Fade>
    </Modal>
  );
}
